import { Component, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ProductoMontoAliado } from '../../../_models/producto-monto-aliado';
import { ProductoMontoAliadoService } from '../../../_services/producto-monto-aliado.service';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { forkJoin } from 'rxjs';
import { PerfilRiesgo } from '../../../_models/perfil-riesgo';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';
import { ProductoService } from '../../../_services/producto.service';
import { ProductoDestinoService } from '../../../_services/producto-destino.service';
import { ProductoDestino } from '../../../_models/producto-destino';
import { AppSettingService } from '../../../_services/app-setting.service';
import { ProductoSubdestinoMontoAliadoService } from '../../../_services/producto-subdestino-monto-aliado.service';
import { ProductoSubdestinoMontoAliado } from '../../../_models/producto-subdestino-monto-aliado';
import { ProductosSubdestinosMontosAliadosActividadService } from '../../../_services/productos-subdestinos-montos-aliados-actividad.service';
import { ProductosSubdestinosMontosAliadosActividad } from '../../../_models/productos-subdestinos-montos-aliados-actividad';
import { Dialog } from 'primeng/dialog';
import { sleep } from '../../../utils/utilidades';

@Component( {
  selector: 'app-producto-monto-aliado',
  templateUrl: 'producto-monto-aliado.component.html'
} )

export class ProductoMontoAliadoComponent implements OnInit {
  @Input() producto: Producto;
  @Input() verDetalle: false;
  @ViewChild('dialo') dialogo: Dialog;
  carInformacionInicial = true;
  lisProductoMontoAliado: ProductoMontoAliado[] = [];
  lisProductoMontoAliadoTodos: ProductoMontoAliado[] = [];
  formulario: FormGroup;
  forDestinos: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  lisTodosPerfiles: PerfilRiesgo[] = [];
  lisDestinos: SelectItem[] = [];
  lisDestinosTodos: ListaItem[] = [];
  lisPerfiles: SelectItem[] = [];
  lisCiclos: SelectItem[] = [];
  subDestinos = false;
  guaDestinos = false;
  proDestinoAliado: ProductoDestino;
  listadoCiclosTodos: ListaItem[] = [];
  lisSubdestino: SelectItem[] = [];
  lisSubdestinoTodos: ListaItem[] = [];
  edMontoAliado: ProductoMontoAliado;
  edit = false;
  lisSubdestinoMonto: ProductoSubdestinoMontoAliado[] = [];
  lisSubdestinoMontoTodos: ProductoSubdestinoMontoAliado[] = [];
  listActividadesTodas: ListaItem[] = [];
  listActividades: SelectItem[] = [];
  lisProductosSubdestinosMontosAliadosActividad: ProductosSubdestinosMontosAliadosActividad[] = [];
  tituloDetalle: string;
  textoDetalle: string;
  detalle: boolean;
  formActividades: FormGroup;
  subActividades = false;
  carActividades = false;
  mosActividades = false;
  regSeleccionado: ProductoMontoAliado;
  lisSubDestinoActividad: SelectItem[] = [];
  colActividades: any[] = [];
  lisActividadesMostrar: ProductosSubdestinosMontosAliadosActividad[] = [];
  errorIndicadores = false;

  constructor( private proMontoAliadServicio: ProductoMontoAliadoService,
               private navServicio: NavService,
               private location: Location,
               private fb: FormBuilder,
               private lisServicio: ListaService,
               private perRiesgoServicio: PerfilRiesgoService,
               private proServicio: ProductoService,
               private proDestinoServicio: ProductoDestinoService,
               private conServicio: ConfirmationService,
               public appSettingService: AppSettingService,
               private proSubdestinoService: ProductoSubdestinoMontoAliadoService,
               private productosSubdestinosMontosAliadosActividadService: ProductosSubdestinosMontosAliadosActividadService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'destinoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINOMONTO.LBL_DESTINO' ), sort: false },
      { field: 'subDestino', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_SUBDESTINOS' ), sort: false },
      { field: 'nombreRiesgo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_PERFIL' ), sort: false },
      { field: 'ciclo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_CICLO' ), sort: false },
      { field: 'montoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_MONTOMAXIMO' ), sort: false },
      { field: 'plazoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.LBL_PLAZOMAXIMO' ), sort: false },
      {
        field: 'plazoMaximoGarantiaIdonea',
        header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIAMESES' ),
        sort: false
      },
      { field: 'indicadorAnalizamos', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORANALIZAMOS' ), sort: false },
      { field: 'indicadorFlujoDigital', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORFLUJODIGITAL' ), sort: false }
    ];
    this.colActividades = [
      { field: 'subDestinoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_SUBDESTINOS' ), sort: false },
      { field: 'actividadRelacionada', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_ACTIVIDAD' ), sort: false }
    ];
    if ( !this.verDetalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
      this.colActividades.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }

    forkJoin( this.proMontoAliadServicio.listadoPorProducto( this.producto.idProducto ),
      this.perRiesgoServicio.listadoHabilitados(),
      this.proDestinoServicio.listadoPorProducto( this.producto.idProducto ),
      this.lisServicio.getMasterDetails( 'ListasDestinosProductos' ),
      this.lisServicio.getMasterDetails( 'ListasPerfilesCiclos' ),
      this.lisServicio.getMasterDetails( 'ListasSubDestinosProductos' ),
      this.lisServicio.getMasterDetails( 'ListasActividadesRelacionadas' ),
      this.proSubdestinoService.listadoPorProducto( this.producto.idProducto ),
      this.productosSubdestinosMontosAliadosActividadService.listaProducto( this.producto.idProducto ) ).subscribe( ( [ lisProductosMontosAliados, lisPerfiles, lisProductoDestinos, lisDestinos, lisCiclos, subdestino, listActividades, subdestinoMonto, montosAliadosActividad ] ) => {
      this.lisProductoMontoAliadoTodos = lisProductosMontosAliados;
      this.lisTodosPerfiles = lisPerfiles;
      this.listadoCiclosTodos = lisCiclos;
      this.lisSubdestinoTodos = subdestino;
      this.lisDestinosTodos = lisDestinos;
      this.lisSubdestinoMontoTodos = subdestinoMonto;
      console.log( this.lisSubdestinoMontoTodos );
      this.listActividadesTodas = listActividades;
      this.lisProductosSubdestinosMontosAliadosActividad = montosAliadosActividad;
      lisDestinos.map( ( s: ListaItem ) => {
        this.lisDestinos.push( { label: s.nombre, value: s.idLista } );
      } );
      subdestino.map( ( s: ListaItem ) => {
        this.lisSubdestino.push( { label: s.nombre, value: s.idLista } );
      } );
      const a = lisProductoDestinos.find( x => x.indicadorAliado );
      if ( a ) {
        this.proDestinoAliado = a;
      }

      this.listadoCiclosTodos.forEach( e => {
        this.lisCiclos.push( { label: e.nombre, value: e.idLista } );
      } );

      this.cargarFormulario();
      this.validarIndicadores();
      this.cargarFormularioActividades();
      this.cargarPerfiles();
      if ( this.lisProductoMontoAliadoTodos.length > 0 ) {
        this.cargarListadoInicial();
      } else {
        this.carInformacionInicial = false;
      }
    } );
  }

  cargarListado() {
    this.lisProductoMontoAliado = [ ...this.lisProductoMontoAliadoTodos.filter( x => x.indicadorHabilitado ) ];
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoMontoAliado: [ null ],
      idPerfilRiesgo: [ null, [ Validators.required ] ],
      idListaPerfilesCiclos: [ null, [ Validators.required ] ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      montoMaximo: [ null, [ Validators.required, Validators.maxLength( 9 ) ] ],
      plazoMaximo: [ null, [ Validators.required, Validators.maxLength( 3 ) ] ],
      indicadorAnalizamos: [ false ],
      indicadorFlujoDigital: [ false ],
      indicadorHabilitado: [ true ],
      auditoriaUsuario: [ null ],
      auditoriaFecha: [ null ],
      idDestinos: [ [], [ Validators.required ] ],
      idSubdestino: [ [] ],
      indicadorGarantiaIdonea: [ false ],
      plazoMaximoGarantiaIdonea: [ null ]
    } );

  }

  cargarPerfiles() {
    this.lisPerfiles = [];
    this.lisTodosPerfiles.forEach( ( s: PerfilRiesgo ) => {
      this.lisPerfiles.push( { label: s.nombreRiesgo, value: s.idPerfilRiesgo } );
      /*if ( !!this.listadoCiclosTodos.find( x => !this.lisProductoMontoAliado.find( y => y.idPerfilRiesgo === s.idPerfilRiesgo && y.idListaPerfilesCiclos === x.idLista ) ) ) {
        this.lisPerfiles.push( { label: s.nombreRiesgo, value: s.idPerfilRiesgo } );
      }*/
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get fDestinos() {
    return this.forDestinos.controls;
  }

  inhabilitar( proMontosAliados: ProductoMontoAliado ) {

    if ( this.producto.indicadorHabilitado && this.lisProductoMontoAliado.length == 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'montos-aliados',
        accept: () => {
          this.carInformacionInicial = true;
          proMontosAliados.indicadorHabilitado = false;
          this.proMontoAliadServicio.actualizar( proMontosAliados ).subscribe( regActualizado => {

            const registro = this.lisProductoMontoAliadoTodos.find( x => x.idProductoMontoAliado === proMontosAliados.idProductoMontoAliado );
            if ( registro ) {
              registro.indicadorHabilitado = false;
            }
            const lisDestino = this.lisSubdestinoMontoTodos.filter( sub => sub.idProductoMontoAliado === proMontosAliados.idProductoMontoAliado );

            if ( lisDestino ) {
              lisDestino.forEach( e => {
                e.indicadorHabilitado = false;
              } );
              this.proSubdestinoService.bulk( lisDestino ).subscribe( async sub => {
                const subDestinosMontoActividad = [];
                sub.forEach( s => {
                  const filtroActDes = this.lisProductosSubdestinosMontosAliadosActividad.filter( act => act.idProductoSubDestinoMontoAliado === s.idProductoSubDestinoMontoAliado );
                  filtroActDes.forEach( l => {
                    l.indicadorHabilitado = false;
                    subDestinosMontoActividad.push( l );
                  } );
                } );
                if ( subDestinosMontoActividad.length > 0 ) {
                  const res = await this.productosSubdestinosMontosAliadosActividadService.bulk( subDestinosMontoActividad ).toPromise();
                }
                this.cargarListado();
                this.cargarPerfiles();
                /*if ( this.f.idPerfilRiesgo.value ) {
                  this.cambiarPerfil( this.f.idPerfilRiesgo.value );
                }*/
                this.navServicio.setMesage( 2 );
                this.carInformacionInicial = false;
              } );
            } else {
              this.cargarListado();
              this.cargarPerfiles();
              /*if ( this.f.idPerfilRiesgo.value ) {
                this.cambiarPerfil( this.f.idPerfilRiesgo.value );
              }*/
              this.navServicio.setMesage( 2 );
              this.carInformacionInicial = false;
            }


          } );
        },
        reject: () => {
        }
      } );
    }

  }

  /* cambiarPerfil( valor: number ) {
    if( this.edit ) {
      return;
    }
    this.lisCiclos = [];
    this.listadoCiclosTodos.forEach( e => {
      if ( !this.lisProductoMontoAliado.find( y => y.idPerfilRiesgo == valor && e.idLista === y.idListaPerfilesCiclos && ((y.indicadorAnalizamos && this.f.indicadorAnalizamos.value) || (y.indicadorFlujoDigital && this.f.indicadorFlujoDigital.value)) ) ) {
        this.lisCiclos.push( { label: e.nombre, value: e.idLista } );
      }
    } );
    if ( this.f.idListaPerfilesCiclos.value && !this.lisCiclos.find(x => x.value === this.f.idListaPerfilesCiclos.value) ) {
      this.f.idListaPerfilesCiclos.setValue( null );
    }
  } */

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && !this.errorIndicadores ) {
      this.guardando = true;
      let desAgregar = [];
      desAgregar = this.validarDestino();
      if ( desAgregar.length > 0 ) {
        this.proMontoAliadServicio.bulk( desAgregar ).subscribe( monto => {
          this.verGuardado( monto );
        }, error => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.MSG_REGISTROEXISTEOREPETIDO' )
        } );
        this.guardando = false;
      }


      /*const existe = this.lisProductoMontoAliadoTodos.find( x => x.idPerfilRiesgo === proMontoDestino.idPerfilRiesgo &
        & x.idListaPerfilesCiclos === proMontoDestino.idListaPerfilesCiclos );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        existe.montoMaximo = proMontoDestino.montoMaximo;
        existe.plazoMaximo = proMontoDestino.plazoMaximo;

      } else if ( !existe ) {
        this.proMontoAliadServicio.crear( proMontoDestino ).subscribe( monto => {
          proMontoDestino.idProductoMontoAliado = monto.idProductoMontoAliado;
          const a = this.lisTodosPerfiles.find( x => x.idPerfilRiesgo === proMontoDestino.idPerfilRiesgo );
          if ( a ) {
            proMontoDestino.nombreRiesgo = a.nombreRiesgo;
          }
          const ciclo = this.listadoCiclosTodos.find( x => x.idLista === proMontoDestino.idListaPerfilesCiclos );
          if ( ciclo ) {
            proMontoDestino.ciclo = ciclo.nombre;
            proMontoDestino.codigoCiclo = ciclo.codigo;
          }
          this.lisProductoMontoAliadoTodos.push( proMontoDestino );
          this.verGuardado(monto);
        }, error => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTOMONTOALIADO.MSG_REGISTROEXISTE' )
        } );
        this.guardando = false;
      }*/


    }
  }


  verGuardado( destino: any ) {
    const proDestinioMonto = this.formulario.value;
    this.actualizarTabla( destino );
    let sudAgregar = [];
    sudAgregar = this.listaSubDestino( destino );
    if(sudAgregar.length > 0){
      const lisActividadInhabilitar = [];
      this.proSubdestinoService.bulk( sudAgregar ).subscribe( async sub => {
        sub.map( x => {
          const existe = this.lisSubdestinoMontoTodos.find( s => s.idProductoSubDestinoMontoAliado === x.idProductoSubDestinoMontoAliado );
          if ( !existe ) {
            const item = this.lisSubdestinoTodos.find( y => y.idLista === x.idSubDestinoProducto );
            x.subDestinoProducto = item ? item.nombre : null;
            this.lisSubdestinoMontoTodos.push( x );
          } else {
            existe.indicadorHabilitado = x.indicadorHabilitado;
            if ( !existe.indicadorHabilitado ) {
              this.lisProductosSubdestinosMontosAliadosActividad.forEach( y => {
                if ( y.indicadorHabilitado && y.idProductoSubDestinoMontoAliado === existe.idProductoSubDestinoMontoAliado ) {
                  y.indicadorHabilitado = false;
                  lisActividadInhabilitar.push( y );
                }
              } );
            }
          }
        } );
        if ( lisActividadInhabilitar.length > 0 ) {
          await this.productosSubdestinosMontosAliadosActividadService.bulk( lisActividadInhabilitar ).toPromise();
        }
        this.setFinalizarGuardado();
      } );
    } else {
      this.setFinalizarGuardado();
    }

  }

  validarIndicadores(){
    this.errorIndicadores = !this.f.indicadorAnalizamos.value && !this.f.indicadorFlujoDigital.value;
  }

  setFinalizarGuardado() {
    this.f.plazoMaximoGarantiaIdonea.setValidators( [] );
    this.cargarFormulario();
    this.f.idProducto.setValue( this.producto.idProducto );
    this.f.indicadorHabilitado.setValue( true );
    this.f.indicadorGarantiaIdonea.setValue( false );
    this.f.indicadorAnalizamos.setValue( false );
    this.f.indicadorFlujoDigital.setValue( false );
    this.cargarListado();
    this.cargarPerfiles();
    this.validarIndicadores();
    this.submitted = false;
    this.guardando = false;
    this.edit = false;
    this.navServicio.setMesage( 1 );
  }

  listaSubDestino( destino: any ) {
    const proDestinoCrear = this.formulario.value;
    let sudAgregar = [];
    destino.map( ( s: ProductoMontoAliado ) => {
      const lisDestino = this.lisSubdestinoMontoTodos.filter( sub => sub.idProductoMontoAliado === s.idProductoMontoAliado );
      proDestinoCrear.idSubdestino.map( sud => {
        let temp = {} as ProductoSubdestinoMontoAliado;
        temp.idProductoMontoAliado = s.idProductoMontoAliado;
        temp.idSubDestinoProducto = sud;
        temp.indicadorHabilitado = true;
        if ( lisDestino.length > 0 ) {
          const existe = lisDestino.find( p => p.idSubDestinoProducto === sud );
          if ( existe ) {
            temp.idProductoSubDestinoMontoAliado = existe.idProductoSubDestinoMontoAliado;
          }
        }
        sudAgregar.push( temp );
      } );

      if ( lisDestino.length > 0 ) {
        lisDestino.forEach( e => {
          if ( e.indicadorHabilitado && !proDestinoCrear.idSubdestino.find( y => y === e.idSubDestinoProducto ) ) {
            e.indicadorHabilitado = false;
            sudAgregar.push( e );
          }
        } );
      }


    } );
    return sudAgregar;
  }

  validarDestino() {
    const desAgregar = [];
    const proMontoDestino = this.formulario.value;

    if ( proMontoDestino.idDestinos ) {
      proMontoDestino.idDestinos.map( s => {
        let temp = {} as ProductoMontoAliado;
        temp.idDestinoProducto = s;
        temp.idPerfilRiesgo = proMontoDestino.idPerfilRiesgo;
        temp.idListaPerfilesCiclos = proMontoDestino.idListaPerfilesCiclos;
        temp.indicadorHabilitado = true;
        temp.montoMaximo = proMontoDestino.montoMaximo;
        temp.plazoMaximo = proMontoDestino.plazoMaximo;
        temp.indicadorGarantiaIdonea = proMontoDestino.indicadorGarantiaIdonea;
        temp.plazoMaximoGarantiaIdonea = proMontoDestino.plazoMaximoGarantiaIdonea;
        temp.indicadorAnalizamos = proMontoDestino.indicadorAnalizamos;
        temp.indicadorFlujoDigital = proMontoDestino.indicadorFlujoDigital;
        temp.idProducto = this.producto.idProducto;
        const existe = this.lisProductoMontoAliadoTodos.find( x => x.idPerfilRiesgo === proMontoDestino.idPerfilRiesgo && x.idListaPerfilesCiclos === proMontoDestino.idListaPerfilesCiclos && x.idDestinoProducto === s && (!proMontoDestino.idProductoMontoAliado || proMontoDestino.idProductoMontoAliado !== x.idProductoMontoAliado)  && ((x.indicadorAnalizamos && proMontoDestino.indicadorAnalizamos) || (x.indicadorFlujoDigital && proMontoDestino.indicadorFlujoDigital)) );
        if ( !this.edit ) {
          if ( existe && !existe.indicadorHabilitado ) {
            temp.idProductoMontoAliado = existe.idProductoMontoAliado;
            desAgregar.push( temp );
          } else if ( !existe ) {
            temp.idProductoMontoAliado = null;
            desAgregar.push( temp );
          } else {
            return [];
          }
        } else if ( !existe ) {
          temp.idProductoMontoAliado = this.f.idProductoMontoAliado.value;
          desAgregar.push( temp );
        } else {
          return [];
        }
      } );
      return desAgregar;
    }
  }

  editar( row: ProductoMontoAliado ) {
    this.carInformacionInicial = true;
    this.edit = true;
    this.edMontoAliado = row;
    forkJoin(
      this.proSubdestinoService.listadoPorDestino( row.idProductoMontoAliado ) ).subscribe( ( [ lisTipoVinculacion ] ) => {
      this.lisSubdestinoMonto = lisTipoVinculacion;
      const subDestino = [];
      const destino = [];
      this.lisSubdestinoMonto.forEach( e => {
        if ( e.indicadorHabilitado ) {
          subDestino.push( e.idSubDestinoProducto );
        }
      } );
      destino.push( row.idDestinoProducto );
      this.f.idProductoMontoAliado.setValue( row.idProductoMontoAliado );
      this.f.idPerfilRiesgo.setValue( row.idPerfilRiesgo );
      this.f.idProducto.setValue( this.producto.idProducto );
      this.f.idListaPerfilesCiclos.setValue( row.idListaPerfilesCiclos );
      this.f.montoMaximo.setValue( row.montoMaximo );
      this.f.plazoMaximo.setValue( row.plazoMaximo );
      this.f.indicadorHabilitado.setValue( true );
      this.f.idDestinos.setValue( destino );
      this.f.idSubdestino.setValue( subDestino );
      this.f.indicadorGarantiaIdonea.setValue( row.indicadorGarantiaIdonea );
      this.f.indicadorAnalizamos.setValue( row.indicadorAnalizamos );
      this.f.indicadorFlujoDigital.setValue( row.indicadorFlujoDigital );
      this.cambioGarantia( row.indicadorGarantiaIdonea );
      this.validarIndicadores();
      this.f.plazoMaximoGarantiaIdonea.setValue( row.plazoMaximoGarantiaIdonea );
      this.formulario.markAsPristine();
      this.submitted = false;
      this.carInformacionInicial = false;
    } );
  }


  async actualizarTabla( destino: any ) {
    const proMontoDestino = this.formulario.value;
    let subDestino = '';

    if ( proMontoDestino.idSubdestino ) {
      proMontoDestino.idSubdestino.map( s => {
        const d = this.lisSubdestinoTodos.find( x => x.idLista === s );
        if ( subDestino ) {
          subDestino = subDestino + ', ' + d.nombre;
        } else {
          subDestino = d.nombre;
        }
      } );
    }

    destino.map( async( s: ProductoMontoAliado ) => {
      const existe = this.lisProductoMontoAliadoTodos.find( x => x.idPerfilRiesgo === proMontoDestino.idPerfilRiesgo
        && x.idListaPerfilesCiclos === proMontoDestino.idListaPerfilesCiclos && x.idDestinoProducto === s.idDestinoProducto && ((proMontoDestino.indicadorAnalizamos && x.indicadorAnalizamos) || (proMontoDestino.indicadorFlujoDigital && x.indicadorFlujoDigital)) );
      if ( existe ) {
        existe.indicadorHabilitado = true;
        existe.montoMaximo = proMontoDestino.montoMaximo;
        existe.plazoMaximo = proMontoDestino.plazoMaximo;
        existe.indicadorGarantiaIdonea = proMontoDestino.indicadorGarantiaIdonea;
        existe.plazoMaximoGarantiaIdonea = proMontoDestino.plazoMaximoGarantiaIdonea;
        existe.indicadorAnalizamos = proMontoDestino.indicadorAnalizamos;
        existe.indicadorFlujoDigital = proMontoDestino.indicadorFlujoDigital;
        if ( subDestino.length > 45 ) {
          existe.subDestinoCorto = subDestino.substring( 0, 45 );
          existe.subDestino = subDestino;
          existe.verCompleto = true;
        } else {
          existe.subDestinoCorto = subDestino;
          existe.subDestino = subDestino;
          existe.verCompleto = false;
        }
      } else {
        const b = this.lisDestinosTodos.find( x => x.idLista === s.idDestinoProducto );
        if ( b ) {
          s.destinoProducto = b.nombre;
        }
        const a = this.lisTodosPerfiles.find( x => x.idPerfilRiesgo === s.idPerfilRiesgo );
        if ( a ) {
          s.nombreRiesgo = a.nombreRiesgo;
        }
        const ciclo = this.listadoCiclosTodos.find( x => x.idLista === s.idListaPerfilesCiclos );
        if ( ciclo ) {
          s.ciclo = ciclo.nombre;
          s.codigoCiclo = ciclo.codigo;
        }
        if ( subDestino.length > 45 ) {
          s.subDestinoCorto = subDestino.substring( 0, 45 );
          s.subDestino = subDestino;
          s.verCompleto = true;
        } else {
          s.subDestinoCorto = subDestino;
          s.subDestino = subDestino;
          s.verCompleto = false;
        }
        this.lisProductoMontoAliadoTodos.push( s );
      }

    } );
    return true;
  }

  cargarListadoInicial() {
    this.lisProductoMontoAliadoTodos.map( s => {
      if ( s.idProductoMontoAliado ) {
        const lisSubDestino = this.lisSubdestinoMontoTodos.filter( sub => sub.idProductoMontoAliado === s.idProductoMontoAliado );
        let subDestino = '';
        lisSubDestino.map( su => {
          if ( su.indicadorHabilitado ) {
            if ( subDestino ) {
              subDestino = subDestino + ', ' + su.subDestinoProducto;
            } else {
              subDestino = su.subDestinoProducto;
            }
          }
        } );
        if ( subDestino.length > 45 ) {
          s.subDestinoCorto = subDestino.substring( 0, 45 );
          s.subDestino = subDestino;
          s.verCompleto = true;
        } else {
          s.subDestinoCorto = subDestino;
          s.subDestino = subDestino;
          s.verCompleto = false;
        }
      }
      this.lisProductoMontoAliado = [ ...this.lisProductoMontoAliadoTodos.filter( x => x.indicadorHabilitado ) ];
      this.carInformacionInicial = false;
    } );
  }

  cambioGarantia( valor: boolean ) {
    this.f.plazoMaximoGarantiaIdonea.setValidators( valor ? [ Validators.required ] : [] );
    this.f.plazoMaximoGarantiaIdonea.setValue( null );
  }


  detalleTabla( row: ProductoDestino ) {
    this.tituloDetalle = this.navServicio.buscarMensaje(
      'PRODUCTODESTINO.LBL_SUBDESTINOS'
    );
    this.textoDetalle = row.subDestino;
    this.detalle = true;
  }

  detalleTablaAct( row: ProductoDestino ) {
    this.tituloDetalle = this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_ACTIVIDAD' );
    this.textoDetalle = row.actividadRelacionada;
    this.detalle = true;
  }

  cargarFormularioActividades() {
    this.formActividades = this.fb.group( {
      idActividadRelacionada: [ [], [ Validators.required ] ],
      idSubdestino: [ null, [ Validators.required ] ]
    } );
  }

  verActividades( row: ProductoMontoAliado ) {
    this.regSeleccionado = row;
    this.lisSubDestinoActividad = [];
    this.lisSubdestinoMontoTodos.forEach( e => {
      if ( e.indicadorHabilitado && e.idProductoMontoAliado === this.regSeleccionado.idProductoMontoAliado ) {
        this.lisSubDestinoActividad.push( { label: e.subDestinoProducto, value: e.idProductoSubDestinoMontoAliado } );
      }
    } );
    this.cargarActividadesMostrar();
    this.mosActividades = true;
  }

  async guardarActividades() {
    this.subActividades = true;
    if ( !this.formActividades.valid ) {
      return;
    }
    this.carActividades = true;
    const formulario = this.formActividades.value;
    const listadoEnviar = [];
    const itemSubdestino = this.lisSubDestinoActividad.find( x => x.value === formulario.idSubdestino );
    formulario.idActividadRelacionada.forEach( e => {
      const existe = this.lisProductosSubdestinosMontosAliadosActividad.find( y => y.idProductoSubDestinoMontoAliado === formulario.idSubdestino && y.idActividadRelacionada === e );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        listadoEnviar.push( existe );
      } else if ( !existe ) {
        const itemActividad = this.listActividades.find( m => m.value === e );
        const nueRegistro = {} as ProductosSubdestinosMontosAliadosActividad;
        nueRegistro.idActividadRelacionada = e;
        nueRegistro.indicadorHabilitado = true;
        nueRegistro.idProductoSubDestinoMontoAliado = formulario.idSubdestino;
        nueRegistro.subDestinoProducto = itemSubdestino ? itemSubdestino.label : null;
        nueRegistro.actividadRelacionada = itemActividad ? itemActividad.label : null;
        listadoEnviar.push( nueRegistro );
      }
    } );
    if ( listadoEnviar.length > 0 ) {
      const actualizado = await this.productosSubdestinosMontosAliadosActividadService.bulk( listadoEnviar ).toPromise();
      listadoEnviar.forEach( e => {
        if ( !e.idProductoSubDestinoMontoAliadoActividad ) {
          const reg = actualizado.find( m => m.idActividadRelacionada === e.idActividadRelacionada );
          if ( reg ) {
            e.idProductoSubDestinoMontoAliadoActividad = reg.idProductoSubDestinoMontoAliadoActividad;
            this.lisProductosSubdestinosMontosAliadosActividad.push( e );
          }
        }
      } );
    }
    this.cargarActividadesMostrar();
    this.navServicio.setMesage( 2 );
    this.reiniciarActividades();
    this.centrarDialogo();
  }

  async centrarDialogo() {
    await sleep( 50 );
    this.dialogo.center();
  }

  cargarActividades( idSubdestino: string ) {
    this.listActividades = [];
    this.listActividadesTodas.forEach( e => {
      if ( !this.lisProductosSubdestinosMontosAliadosActividad.find( y => y.indicadorHabilitado && y.idProductoSubDestinoMontoAliado === idSubdestino && y.idActividadRelacionada === e.idLista ) ) {
        this.listActividades.push( { label: e.nombre, value: e.idLista } );
      }
    } );

    if ( this.fAct.idActividadRelacionada.value && this.fAct.idActividadRelacionada.value.length > 0 ) {
      const lisAsignar = this.fAct.idActividadRelacionada.value.filter( x => !!this.listActividades.find( y => y.value === x ) );
      this.fAct.idActividadRelacionada.setValue( lisAsignar );
    }
  }

  cargarActividadesMostrar() {
    this.lisActividadesMostrar = this.lisProductosSubdestinosMontosAliadosActividad.filter( x => x.indicadorHabilitado && !!this.lisSubDestinoActividad.find( m => m.value === x.idProductoSubDestinoMontoAliado ) );
  }

  cerrarModal() {
    this.mosActividades = false;
    this.reiniciarActividades();
    this.regSeleccionado = null;
    this.lisSubDestinoActividad = [];
  }

  reiniciarActividades() {
    this.formActividades.reset();
    this.listActividades = [];
    this.subActividades = false;
    this.carActividades = false;
  }

  get fAct() {
    return this.formActividades.controls;
  }

  inhabilitarActividad( row: ProductosSubdestinosMontosAliadosActividad ) {
    this.carActividades = true;
    row.indicadorHabilitado = false;
    this.productosSubdestinosMontosAliadosActividadService.actualizarSubDestinosMontoAliados( row ).subscribe( r => {
      this.cargarActividadesMostrar();
      if ( this.fAct.idSubdestino.value ) {
        this.cargarActividades( this.fAct.idSubdestino.value );
      }
      this.navServicio.setMesage( 2 );
      this.carActividades = false;
    } );
  }
}
